import { render } from "./identity.vue?vue&type=template&id=0c6ebb3c&scoped=true"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"

import "./identity.vue?vue&type=style&index=0&id=0c6ebb3c&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6ebb3c"]])

export default __exports__